import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../lib/auth-store';
import { LanguageSelect } from '../../components/LanguageSelect';
import { useLanguage } from '../../lib/i18n';

export function AdminShell() {
  const admin = useAuth((state) => state.adminSession);
  const logout = useAuth((state) => state.logout);
  const { language } = useLanguage();
  const en = language === 'en';

  if (!admin) return null;

  return (
    <div className="app-shell">
      <nav className="sidebar" aria-label="VganttAdmin menüsü">
        <div className="sidebar__brand">
          VganttAdmin
          <span className="sidebar__tenant">{admin.fullName} · {admin.role}</span>
        </div>

        <NavLink to="/admin" end className="nav-item">{en ? 'Overview' : 'Genel Bakış'}</NavLink>
        <NavLink to="/admin/tenants" className="nav-item">{en ? 'Companies' : 'Şirketler'}</NavLink>
        <NavLink to="/admin/modules" className="nav-item">{en ? 'Module licenses' : 'Modül Lisansları'}</NavLink>
        <NavLink to="/admin/billing" className="nav-item">{en ? 'Billing' : 'Ödeme Takibi'}</NavLink>

        <div style={{ marginTop: 'auto' }}>
          <LanguageSelect />
          <button type="button" className="button button--ghost" onClick={() => void logout()}>{en ? 'Sign out' : 'Çıkış yap'}</button>
        </div>
      </nav>

      <main className="main"><Outlet /></main>
    </div>
  );
}
